import React, { FC } from "react"
import { Path, Svg, View } from "@react-pdf/renderer"

export type PdfIcon = {
    fill: string
}
const SouthEast: FC<PdfIcon> = (props) => {
    const { fill } = props;
    return (
        <View style={{height: 20, width: 20}}>
            <Svg height={30} width={30}>
                <Path d="M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10z" 
                    fill={fill || "currentColor"} // Set fill from props or default to 'currentColor'
                />
            </Svg>
        </View>
    )
}

export default SouthEast;